import { render } from "./StepSix.vue?vue&type=template&id=505a249b&scoped=true"
import script from "./StepSix.vue?vue&type=script&lang=js"
export * from "./StepSix.vue?vue&type=script&lang=js"

import "./StepSix.vue?vue&type=style&index=0&id=505a249b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505a249b"]])

export default __exports__